import React from 'react';
import styled from 'styled-components';

import {IconoirNavArrowRight} from '@ey-xd/motif-icon';

import Icon from '@ey/canvascoreservices/Icon';

const StyledIcon = styled(Icon)`
	display: flex;
`;

export const config = () => ({
	id: 'actionsColumn',
	label: '',
	propName: 'delete',
	width: 'var(--px-66)',
	customCell: (item) => {
		const props = {src: IconoirNavArrowRight};
		return <StyledIcon {...props} />;
	}
});
